export const displayGreeting = () => {
  const date = new Date();
  const hour = date.getHours();

  if (hour >= 5 && hour <= 12) {
    return 'Good Morning';
  }

  if (hour > 12 && hour <= 18) {
    return 'Good Afternoon';
  }

  if (hour > 18 && hour <= 22) {
    return 'Good Evening';
  }

  if (hour > 22 || hour < 5) {
    return 'Hello';
  }
};
